
import { useState, useMemo } from 'react';

export const useFilters = (indicators, perspectives, indicatorTypes) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPerspective, setSelectedPerspective] = useState("All");
  const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
    .toISOString()
    .split("T")[0]);
  const [showOnlyUnseen, setShowOnlyUnseen] = useState(true);
  const [endDate, setEndDate] = useState("");
  const [dashboardFilters, setDashboardFilters] = useState({
    perspectives: [],
    indicators: [],
  });

  // Initialize dashboard filters when data loads
  useMemo(() => {
    if (perspectives.length > 0 && indicatorTypes.length > 0 && dashboardFilters.perspectives.length === 0) {
      setDashboardFilters({
        perspectives: [...perspectives],
        indicators: [...indicatorTypes],
      });
    }
  }, [perspectives, indicatorTypes, dashboardFilters.perspectives.length]);

  const filteredData = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    return indicators.filter((item) => {
      const matchesSearch =
        !term ||
        item.indicator.toLowerCase().includes(term) ||
        item.notes.toLowerCase().includes(term) ||
        item.result_analysis.toLowerCase().includes(term) ||
        item.proposed_actions.toLowerCase().includes(term) ||
        item.perspective.toLowerCase().includes(term) ||
        item.checked.toString().toLowerCase().includes(term);

      const matchesPerspective =
        selectedPerspective === "All" ||
        item.perspective === selectedPerspective;

      const itemDate = new Date(item.period);
      const matchesStartDate =
        !startDate || itemDate >= new Date(startDate);
      const matchesEndDate =
        !endDate || itemDate <= new Date(endDate);
      if (item.indicator === 'Lucro Líquido') {
        console.log('Item com indicador N/A encontrado:', item);
      }
      const isSeen = (item.checked === 'T' || item.checked === true);
      const matchesSeen = !showOnlyUnseen || !isSeen;
      return (
        matchesSearch &&
        matchesPerspective &&
        matchesStartDate &&
        matchesEndDate && matchesSeen
      );
    });
  }, [indicators, searchTerm, selectedPerspective, startDate, endDate, showOnlyUnseen]);

  const uniqueIndicatorsForDashboard = useMemo(() => {
    if (dashboardFilters.perspectives.length === 0 || dashboardFilters.indicators.length === 0) {
      return [];
    }

    const filtered = indicators.filter(
      (ind) =>
        dashboardFilters.perspectives.includes(ind.perspective) &&
        dashboardFilters.indicators.includes(ind.indicator),
      dashboardFilters.checked ? ind.visto === false : true
    );
    const uniqueIndicators = [...new Set(filtered.map((ind) => ind.indicator))];

    console.log('Filtros aplicados:', {
      perspectives: dashboardFilters.perspectives,
      indicators: dashboardFilters.indicators,
      filteredCount: filtered.length,
      uniqueIndicators
    });

    return uniqueIndicators;
  }, [indicators, dashboardFilters]);

  const togglePerspectiveFilter = (perspective) => {
    setDashboardFilters(prev => {
      const set = new Set(prev.perspectives);
      if (set.has(perspective)) {
        set.delete(perspective);
      } else {
        set.add(perspective);
      }
      return { ...prev, perspectives: [...set] };
    });
  };

  const toggleIndicatorFilter = (indicator) => {
    setDashboardFilters(prev => {
      const set = new Set(prev.indicators);
      if (set.has(indicator)) {
        set.delete(indicator);
      } else {
        set.add(indicator);
      }
      return { ...prev, indicators: [...set] };
    });
  };

  const selectAllFilters = () => {
    setDashboardFilters({
      perspectives: [...perspectives],
      indicators: [...indicatorTypes],
    });
  };

  const clearAllFilters = () => {
    console.log('Limpando todos os filtros...');
    setSearchTerm("");
    setSelectedPerspective("All");
    setStartDate("");
    setEndDate("");
    setDashboardFilters({
      perspectives: [],
      indicators: [],
    });
  };

  const getDateRange = () => {
    if (indicators.length === 0) return { min: "", max: "" };

    const dates = indicators
      .map((i) => new Date(i.period))
      .sort((a, b) => a - b);
    // ajustado para sempre abrir posicionado no último período disponível
    //setStartDate(dates[dates.length - 1].toISOString().split("T")[0]);
    return {
      min: dates[0].toISOString().split("T")[0],
      max: dates[dates.length - 1].toISOString().split("T")[0],
    };
  };

  const setQuickPeriod = (months) => {
    if (months === 0) {
      setStartDate("");
      setEndDate("");
      return;
    }

    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth() - months, 1);

    setStartDate(start.toISOString().split("T")[0]);
    setEndDate(now.toISOString().split("T")[0]);
  };

  return {
    searchTerm,
    setSearchTerm,
    selectedPerspective,
    setSelectedPerspective,
    startDate,
    setStartDate,
    endDate,
    showOnlyUnseen,
    setShowOnlyUnseen,
    setEndDate,
    dashboardFilters,
    togglePerspectiveFilter,
    toggleIndicatorFilter,
    selectAllFilters,
    clearAllFilters,
    setQuickPeriod,
    filteredData,
    uniqueIndicatorsForDashboard,
    getDateRange
  };
};
